/* eslint-disable semi */
import { createDecorator } from 'vue-class-component';
import * as utils from './utils';
import DecoratorConfigs from './DecoratorConfigs';

const debug = process.env.NODE_ENV === 'development';

const DECORATOR_NAME = 'BindDefault';

/**
 * コンポーネントにデフォルト値へのアクセッサを追加します
 *
 * コンポーネントに下記を追加します。
 * this.$_sas.$default: デフォルト値
 *
 * そのコンポーネントのdataメソッドが返却するデータをデフォルト値として返却します。
 * data () {
 *   return {
 *     val1:{...},
 *     val2:{...}
 *   }
 * }
 * という定義である場合、下記の変数を参照可能です。
 * this.$_sas.$default.val1
 * this.$_sas.$default.val2
 */
export default function BindDefault (...args) {
  if (utils.isDecoratorCall(args)) {
    createAppDecorator()(...args);
  } else {
    if (debug) {
      console.error(`${DECORATOR_NAME}: USAGE @${DECORATOR_NAME}`);
    }
    return createAppDecorator(...args);
  }
}

function createAppDecorator (decoratorOptions = {}) {
  // 設定値のマージ
  decoratorOptions = DecoratorConfigs.marge(DECORATOR_NAME, decoratorOptions);

  // 実装時の整合性チェック
  if (debug) {
    utils.validateDecoratorOptions(DECORATOR_NAME, {}, decoratorOptions);
  }

  return createDecorator((options, key) => {
    // 実装時の整合性チェック
    if (debug) {
      console.debug(`${DECORATOR_NAME}: @ ${key}`);

      if (key !== 'data') {
        throw new Error(`${DECORATOR_NAME}: can decorate only data().`);
      }
    }

    // データメソッド
    const data = options.data;

    // created時の処理を追加
    const created = options.created || function () { };
    options.created = utils.injectBefore(created, function () {
      // デコレータ管理用変数初期化
      this.$_sas = this.$_sas || {};
      this.$_sas.$default = {};

      // this.$_sas.$defaultを介してdata()が返却するデフォルト値にアクセスするためのgetterを生成する。
      for (let key in data()) {
        Object.defineProperty(this.$_sas.$default, key, {
          configurable: true,
          enumerable: true,
          get: function () {
            return data()[key];
          }
        });
      }
    });

    // destroyed時の処理を追加
    const destroyed = options.destroyed || function () { };
    options.destroyed = utils.injectAfter(destroyed, function () {
      // デコレータ管理用変数破棄
      if (this.$_sas) {
        if (this.$_sas.$default) {
          for (let key in this.$_sas.$default) {
            delete this.$_sas.$default[key];
          }
          delete this.$_sas.$default;
        }
        if (Object.keys(this.$_sas).length === 0) {
          delete this.$_sas;
        }
      }
    });
  });
}



// WEBPACK FOOTER //
// ./src/core/decorators/BindDefault.js